import { useNavigate, useLocation } from "react-router-dom";
import { BarChart2, ClipboardList, Ship, Sparkles } from "lucide-react";

/**
 * BottomNavBar — mobile-only fixed bottom navigation (hidden sm:hidden)
 * Provides thumb-friendly navigation between primary modules.
 */
export function BottomNavBar({ userRole, onLogout, notifCount = 0 }) {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const items = [
    { label: "Stock", icon: BarChart2, href: "/stock" },
    { label: "Reservations", icon: ClipboardList, href: "/reservations" },
    { label: "Shipments", icon: Ship, href: "/shipments" },
    ...(userRole === "admin" ? [{ label: "Pulse HQ", icon: Sparkles, href: "/master-ai" }] : []),
  ];

  return (
    <nav
      className="sm:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[#E5E7EB] flex items-stretch"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav-bar"
    >
      {items.map(({ label, icon: Icon, href }) => {
        const active = path === href || path.startsWith(href + "/");
        const isReservations = label === "Reservations";
        return (
          <button
            key={href}
            onClick={() => navigate(href)}
            data-testid={`bottom-nav-${label.toLowerCase()}`}
            className={`flex-1 flex flex-col items-center justify-center gap-1 py-3 text-[11px] font-medium transition-colors active:bg-gray-50 relative ${
              active
                ? "text-[#DC2626]"
                : "text-[#6B7280]"
            }`}
          >
            <div className="relative">
              <Icon className={`h-5 w-5 ${active ? "stroke-[2.5]" : "stroke-2"}`} />
              {isReservations && notifCount > 0 && (
                <span
                  className="absolute -top-1.5 -right-2 min-w-[16px] h-4 bg-[#DC2626] text-white text-[9px] font-bold rounded-full flex items-center justify-center px-1 leading-none"
                  data-testid="notif-badge"
                >
                  {notifCount > 9 ? "9+" : notifCount}
                </span>
              )}
            </div>
            {label}
            {active && (
              <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#DC2626] rounded-full" />
            )}
          </button>
        );
      })}
    </nav>
  );
}
